import { render, staticRenderFns } from "./Functionalities.vue?vue&type=template&id=00b671a7&lang=pug&"
import script from "./Functionalities.vue?vue&type=script&lang=ts&"
export * from "./Functionalities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports